import { useEffect, useState } from "react";
import { BellRing } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Switch } from "@/components/ui/switch";

const ESITO = { inviato: "inviata", simulato: "simulata (anteprima)", nessun_destinatario: "nessuna email disponibile" };

// Installatore: attiva/disattiva le email automatiche di fermo impianto al cliente finale
export function AvvisiClienteToggle({ u, params }) {
  const [d, setD] = useState(null);
  const load = () => api.get(u, { params }).then((r) => setD(r.data)).catch(() => setD(null));
  useEffect(() => { load(); }, [u]); // eslint-disable-line react-hooks/exhaustive-deps
  const set = async (v) => {
    try { await api.put(u, { attivo: v }, { params }); toast.success(v ? "Avvisi al cliente attivati" : "Avvisi al cliente disattivati"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Errore"); }
  };
  if (!d) return null;
  return (
    <div className="space-y-1.5 rounded-xl bg-slate-50 p-3" data-testid="avvisi-cliente">
      <label className="flex items-center justify-between gap-3">
        <span className="flex items-start gap-2"><BellRing className="mt-0.5 h-4 w-4 shrink-0 text-amber-500" />
          <span><b className="block text-slate-800">Avvisi email al cliente</b>
            <span className="text-xs text-slate-500">Impianto fermo da almeno 2 ore o senza comunicazione da oltre 24 ore · una mail per evento, tu in copia</span></span></span>
        <Switch checked={d.attivo} onCheckedChange={set} data-testid="avvisi-cliente-switch" />
      </label>
      <p className="text-xs text-slate-500" data-testid="avvisi-cliente-destinatari">Destinatari: {d.destinatari.length ? d.destinatari.join(", ") : "nessuno (manca l'email del cliente)"}</p>
      {d.ultimi.map((x, i) => (
        <p key={i} className="text-xs text-slate-400" data-testid={`avvisi-cliente-log-${i}`}>
          {new Date(x.at).toLocaleString("it-IT")} · {x.tipo === "fermo" ? `fermo da ${x.ore} h` : `non comunica da ${x.ore} h`} · {ESITO[x.esito] || x.esito}</p>
      ))}
    </div>
  );
}
